import { render, staticRenderFns } from "./AmazonPreview.vue?vue&type=template&id=851be4e4&"
import script from "./AmazonPreview.vue?vue&type=script&lang=js&"
export * from "./AmazonPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports